<template>
  <div
    v-cloak
    class="max-w-4xl mx-auto flex items-center justify-start bg-red-100 p-4 rounded-lg vetster-prose text-red-700"
  >
    <fa
      class="fa-fw text-red-600 mr-2 text-2xl"
      :icon="['fal', 'exclamation-circle']"
    />
    <div v-if="Array.isArray(errors)">
      <p
        v-for="(error, key) in errors"
        :key="key"
        :class="key ? ' mt-1' : ''"
        class="text-base"
      >
        {{ error }}
      </p>
    </div>
    <div
      v-else-if="errors"
      class="text-base"
    >
      {{ errors }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'VetsterError',

  props: {
    errors: {
      type: [Array, String],
      required: true,
    },
  },
};
</script>
